import querystring from 'query-string';
import { Query } from '../../types/v2/holiday-search';

export const getPathWithQuery = (path: string, query: Query, hash?: string) =>
  `${path}?${querystring.stringify(query)}${hash ? `#${hash}` : ''}`;
